import { makeLinkWithQueryParams } from '../intents/linkUtils';
import { cmsDevelopers } from './productLinks';
import { getHublet } from '../store/app/selectors';
import { getPortalId } from '../store/auth/selectors';
export const getCMSDeveloperRedirect = state => {
  const portalId = getPortalId(state);
  const hublet = getHublet(state);
  const link = cmsDevelopers({
    portalId,
    hublet
  });
  return makeLinkWithQueryParams({
    link,
    hublet
  });
};